export default __webpack_public_path__ + "assets/images/7f6596b8f02f7c8adea2dc892d4aa9b3.png";